module.exports = __webpack_public_path__ + "static/img/a303.6f83cb99.png";